const ancestor = "首页";
const UserRouter = [
  /* 个人中心 */
  /* menu 可选值 index  share collect favorite community activity */
  {
    path: "/personal/:menu",
    name: "/personal",
    meta: { screen: false, title: "个人中心", keepAlive: true, ancestor },
    component: () => import("@/views/user/personal/Index.vue"),
  },
  /* 隐私设置 */
  {
    path: "/privacy-setting",
    name: "privacy-setting",
    meta: { screen: false, title: "隐私设置", ancestor },
    component: () => import("@/views/user/privacySetting/Index.vue"),
  },
  /* 账号信息 */
  {
    path: "/user/account",
    name: "user-account",
    meta: { screen: false, title: "账号信息", ancestor },
    component: () => import("@/views/user/account/Index.vue"),
  },
  /*  更多用户 */
  {
    path: "/more-user",
    name: "more-user",
    meta: { screen: false, title: "更多用户", ancestor },
    component: () => import("@/views/user/moreUser/Index.vue"),
  },
  /*  个人信息 */
  {
    path: "/personal-profile",
    name: "personal-profile",
    meta: { screen: false, title: "个人信息", ancestor },
    component: () => import("@/views/user/personalProfile/Index.vue"),
  },
  /* TA的主页 */
  {
    path: "/user-detail/:id",
    name: "user-detail",
    meta: { screen: false, title: "TA的主页", keepAlive: true, ancestor },
    component: () => import("@/views/user/detail/Index.vue"),
  },
  /* 关注申请落地页 */
  {
    path: "/user/follow-application/:id",
    name: "user-follow-application",
    meta: { screen: false, title: "关注申请", ancestor },
    component: () => import("@/views/user/followApplication/Index.vue"),
  },
  /* 私信申请 */
  {
    path: "/user/msg-application/:id",
    name: "user-msg-application",
    meta: { screen: false, title: "私信申请", ancestor },
    component: () => import("@/views/user/msgApplication/Index.vue"),
  },
  /* 加群申请 */
  {
    path: "/user/join-comm-application/:id",
    name: "/user/join-comm-application",
    meta: { screen: false, title: "加入社群申请", ancestor },
    component: () => import("@/views/user/joinCommApplication/Index.vue"),
  },
  {
    path: "/user/crawler/paper/edit/:id",
    name: "crawler-paper-edit",
    meta: { screen: false, title: "编辑论文", ancestor },
    component: () => import("@/views/user/crawler/CrawlerPaperEdit.vue"),
  },
  {
    path: "/user/crawler/patent/edit/:id",
    name: "crawler-patent-edit",
    meta: { screen: false, title: "编辑专利", ancestor },
    component: () => import("@/views/user/crawler/CrawlerPatentEdit.vue"),
  },
  {
    path: "/user/crawler/paper/detail/:id",
    name: "crawler-paper-detail",
    meta: { screen: false, title: "论文详情", ancestor },
    component: () => import("@/views/user/crawler/CrawlerPaperDetail.vue"),
  },
  {
    path: "/user/crawler/patent/detail/:id",
    name: "crawler-patent-detail",
    meta: { screen: false, title: "专利详情", ancestor },
    component: () => import("@/views/user/crawler/CrawlerPatentDetail.vue"),
  },
];
export default UserRouter;
